import { AssignmentTypeEnum, WorkerTypeEnum } from 'api/backofficeApiClient';

export const getWorkerTypeLabel = (workerType?: WorkerTypeEnum) => {
  switch (workerType) {
    case WorkerTypeEnum.IC:
      return 'IC';

    case WorkerTypeEnum.W2:
      return 'W2';

    case WorkerTypeEnum.InternationalIC:
      return 'International IC';

    case WorkerTypeEnum.SC:
      return 'SC';

    default:
      return '';
  }
};

export const getWorkerType = (
  workerType?: string,
): WorkerTypeEnum | undefined => {
  switch (workerType) {
    case 'IC':
      return WorkerTypeEnum.IC;

    case 'W2':
      return WorkerTypeEnum.W2;

    case 'International IC':
      return WorkerTypeEnum.InternationalIC;

    case 'SC':
      return WorkerTypeEnum.SC;

    default:
      return;
  }
};

export const getWorkerTypeByAssignmentType = (
  assignmentType?: AssignmentTypeEnum,
) => {
  switch (assignmentType) {
    case AssignmentTypeEnum.ICAssignment:
      return WorkerTypeEnum.IC;

    case AssignmentTypeEnum.W2Assignment:
      return WorkerTypeEnum.W2;

    case AssignmentTypeEnum.SCAssignment:
      return WorkerTypeEnum.SC;

    default:
      return undefined;
  }
};
